import { DimensionSizing, DimensionUnit } from 'components/search/expedia/enums';
import { HeightState } from 'components/search/expedia/interfaces';

const initialHeightStates: Record<DimensionSizing, HeightState> = {
  [DimensionSizing.FIXED]: {
    heightSizing: DimensionSizing.FIXED,
    heightSize: 600,
    heightSizeMin: 250,
    heightSizeMax: 600,
    heightSizeStep: 1,
    heightUnit: DimensionUnit.FIXED,
  },
  [DimensionSizing.RELATIVE]: {
    heightSizing: DimensionSizing.RELATIVE,
    heightSize: 100,
    heightSizeMin: 0,
    heightSizeMax: 100,
    heightSizeStep: 0.1,
    heightUnit: DimensionUnit.RELATIVE,
  },
};

const initialFixedHeightState = initialHeightStates[DimensionSizing.FIXED];
const initialRelativeHeightState = initialHeightStates[DimensionSizing.RELATIVE];

export { initialHeightStates, initialFixedHeightState, initialRelativeHeightState };
